import { useEffect } from "react";

import { useDispatch } from "react-redux";

import { getDestinationsTypesRedux } from "redux/slices/destinationsTypes/destinationsTypes.asyncActions";
import { getSourcesTypesRedux } from "redux/slices/sourcesTypes/sourcesTypes.asyncActions";

/**
 * Loads app-wide data once the user is inside a protected route.
 * Add further startup fetches here.
 */
export function useInitApp() {
    const dispatch = useDispatch();

    useEffect(() => {
        const token = window.localStorage.getItem("token");
        if (!token) return;

        dispatch(getSourcesTypesRedux());
        dispatch(getDestinationsTypesRedux());
    }, [dispatch]);
}
